import axios from "axios";
import {
  ACCOUNT,
  DETAILS,
  DELIVERY_ADDRESS_ROUTE,
  RELATED_CONTACTS,
  USER,
  UPDATE_USER_INFO,
  SET_DEFAULT_DELIVERY_ADDRESS,
} from "../../constants/apiLink";
import { showErrorToast } from "../../utils/toastUtils";

export const apiUpdateAccountDeliveryAddress = async (data) => {
  const url = ACCOUNT + DETAILS;
  return axios.put(url, data).then((result) => {
    return result;
  });
};

export const apiCreateAccountDeliveryAddress = async (address) => {
  return axios.post("/api/Addresses", address).then((result) => {
    return result.data;
  });
};

export const apiUpdateDeliveryAddress = async (address) => {
  const url = USER + UPDATE_USER_INFO;
  return axios.patch(url, address).then((result) => {
    return result;
  });
};

export const apiDeleteDeliveryAddress = async (id) => {
  return axios
    .delete(`/api/Addresses/${id}`)
    .then((result) => {
      return result.data;
    })
    .catch((error) => {
      // Handle error response
      console.log(error.response.data);
      if (error.response.data) {
        const data = error.response.data;
        showErrorToast(data?.description);
        return false;
      } else {
        console.log("Error:", error.message);
      }
      return false;
    });
};

export const apiCreateContact = async (data) => {
  data.zipCode = data.zip;
  return axios.post("/api/Addresses", data).then((result) => {
    return result;
  });
};

export const apiUpdateContact = async (data) => {
  const url = RELATED_CONTACTS;
  return axios.patch(url, data).then((result) => {
    return result;
  });
};

// export const apiSetDefaultDeliveryAddress = async (address) => {
//   const url = USER + SET_DEFAULT_DELIVERY_ADDRESS + address;
//   return axios.patch(url, address).then((result) => {
//     return result;
//   });
// };

export const apiGetAddresses = () => {
  return axios.get(`/api/Addresses`).then((result) => {
    if (result) {
      if (result.data) {
        return result.data;
      }
    }
    return false;
  });
};

export const apiSetDefaultAddress = async (
  deliveryId = null,
  pickupId = null
) => {
  const params = new URLSearchParams();
  if (deliveryId !== null) {
    params.append("defaultDeliveryAddressId", deliveryId);
  }
  if (pickupId !== null) {
    params.append("defaultPickUpAddressId", pickupId);
  }
  return axios
    .put(`/api/Addresses/set-default-addresses?${params.toString()}`)
    .then((result) => {
      if (result && result.data) {
        return result.data;
      }
      return false;
    })
    .catch((error) => {
      // Handle error response
      if (error.response) {
        console.log("Error:", error);
      }
    });
};
